export function HPersonalLoansIcon({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M10.1716 20.3257H11.1973V18.9923H13.505C13.6512 18.9923 13.7732 18.9434 13.871 18.8457C13.969 18.7477 14.018 18.6256 14.018 18.4793V14.3257C14.018 14.1794 13.969 14.0574 13.871 13.9597C13.7732 13.8617 13.6512 13.8127 13.505 13.8127H8.37698V10.6847H14.018V9.659H11.1973V8.32567H10.1716V9.659H7.86398C7.71776 9.659 7.59576 9.70789 7.49798 9.80567C7.4002 9.90367 7.35132 10.0257 7.35132 10.1717V14.3257C7.35132 14.4719 7.4002 14.5939 7.49798 14.6917C7.59576 14.7894 7.71776 14.8383 7.86398 14.8383H12.9923V17.9667H7.35132V18.9923H10.1716V20.3257ZM2.73565 24C2.22343 24 1.78765 23.8204 1.42832 23.4613C1.0692 23.102 0.889648 22.6662 0.889648 22.154V1.846C0.889648 1.33378 1.0692 0.897999 1.42832 0.538666C1.78765 0.179555 2.22343 0 2.73565 0H13.8716L19.5563 5.68467V22.154C19.5563 22.6662 19.3768 23.102 19.0177 23.4613C18.6583 23.8204 18.2225 24 17.7103 24H2.73565ZM13.0513 6.04367V1.02567H2.73565C2.53054 1.02567 2.34254 1.11111 2.17165 1.282C2.00076 1.45289 1.91532 1.64089 1.91532 1.846V22.154C1.91532 22.3591 2.00076 22.5471 2.17165 22.718C2.34254 22.8889 2.53054 22.9743 2.73565 22.9743H17.7103C17.9154 22.9743 18.1034 22.8889 18.2743 22.718C18.4452 22.5471 18.5306 22.3591 18.5306 22.154V6.04367H13.0513Z" />
    </svg>
  );
}
